define(function (require, exports, module) {
    var EMPTY_ARR = [];
    var TICKETTYPE = 'mobile';

    function formatLineup (lineup) {
        var formattedLineup = [];
        lineup.forEach(function (player, index) {
            formattedLineup.push({
                person: {
                    id: player.id,
                    lastFirstName: player.lastName + ', ' + player.useName,
                    primaryPosition: player.primaryPosition
                },
                battingOrder: (index + 1) + '00',
                startingPosition: player.primaryPosition
            });
        });
        return formattedLineup;
    }

    function ScheduleApiModel (data) {
        var dates = data && data.dates && data.dates.length && data.dates.slice(-1)[0];
        var game = dates.games && dates.games.slice(-1)[0];
        var broadcasts = game.broadcasts || EMPTY_ARR;
        var homeLineup = game.lineups && game.lineups.homePlayers || EMPTY_ARR;
        var awayLineup = game.lineups && game.lineups.awayPlayers || EMPTY_ARR;
        var scheduleTeams = game.teams;
        var tickets = game.tickets || EMPTY_ARR;
        var xrefIds = game.xrefIds || EMPTY_ARR;

        var nationalBroadcasts = this.nationalBroadcasts = {
            tv: [],
            radio: []
        };

        var promotionIds = this.promotionIds = {};
        this.story = game.story && game.story.link || '';

        var teams = this.teams = {
            home: {
                shortname: 'home',
                tickets: null,
                broadcast: {
                    tv: [],
                    radio: []
                },
                probablePitcher: scheduleTeams.home.probablePitcher,
                lineup: formatLineup(homeLineup)

            },
            away: {
                shortname: 'away',
                tickets: null,
                broadcast: {
                    tv: [],
                    radio: []
                },
                probablePitcher: scheduleTeams.away.probablePitcher,
                lineup: formatLineup(awayLineup)
            }
        };

        var i;
        var len;
        var homeAway;
        var type;
        var target;
        var temp;
        var pushedIds = {};

        /*
         * Sort the broadcasts into team and national buckets.
         * Don't repeat any national broadcasts, check their ids to
         * see if it's been added already.
         */
        for (i = 0, len = broadcasts.length; i < len; i++) {
            temp = broadcasts[i];
            homeAway = temp && temp.homeAway;
            if (!temp.isNational && homeAway) {
                type = temp.type.toLowerCase();
                target = teams[homeAway.toLowerCase()];
                if (target) {
                    if (type === 'tv') {
                        target.broadcast.tv.push({
                            id: temp.id,
                            name: temp.name
                        });
                    } else {
                        target.broadcast.radio.push({
                            id: temp.id,
                            name: temp.name
                        });
                    }
                }
            } else if (!pushedIds[temp.id]) {
                type = temp.type.toLowerCase();
                if (type === 'tv') {
                    nationalBroadcasts.tv.push({
                        id: temp.id,
                        name: temp.name
                    });
                    pushedIds[temp.id] = true;
                } else {
                    nationalBroadcasts.radio.push({
                        id: temp.id,
                        name: temp.name
                    });
                    pushedIds[temp.id] = true;
                }
            }
        }
        for (i = 0, len = tickets.length; i < len; i++) {
            temp = tickets[i];
            if (temp && temp.ticketType === TICKETTYPE && temp.ticketLinks) {
                type = temp.ticketLinks;
                teams.home.tickets = type.home;
                teams.away.tickets = type.away;
                break;
            }
        }

        for (i = 0, len = xrefIds.length; i < len; i++) {
            var xref = xrefIds[i];
            if (xref && xref.xrefId === 'true') {
                promotionIds[xref.xrefType] = true;
            }
        }
    }

    return ScheduleApiModel;
});
